import React, { CSSProperties } from 'react'

import Image from 'app/components/common/image/image.component'

type IconProps = {
  width: number | string
  height?: number | string
  src: string
  alt: string
  className?: string
  style?: CSSProperties
}

const Icon = ({
  width,
  height = 'auto',
  src,
  alt,
  className,
  style,
}: IconProps) => (
  <Image
    src={src}
    alt={alt}
    style={{ objectFit: 'contain', ...style }}
    width={width}
    height={height}
    className={className}
  />
)

export default Icon
